var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('Layout',[_c('PageHeader',{attrs:{"title":_vm.title,"items":_vm.items}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }